<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<el-dialog
		id="cancel-todo-dialog"
		class="custom-confirm-dialog"
		destroy-on-close
		:show-close="false"
		:close-on-click-modal="false"
		:visible.sync="isDialogActiveLocal"
		:title="$t('ConfirmCancelTodo')"
	>
		<div>
			<label>
				{{ $t("Placeholder.InputReasonCancel") }}
				<span class="text-danger">*</span>:
			</label>
			<cbs-textarea class="mt-2" type="textarea" name="reason-reject" v-model="cancelReason" v-validate="'required'" :rows="3" :data-vv-as="$t('ReasonCancel')" />
			<span class="text-danger text-sm" v-show="errors.has('reason-reject')">{{ errors.first("reason-reject") }}</span>
		</div>

		<div class="flex justify-end -mx-6" slot="footer">
			<vs-button type="flat" class="w-1/3 font-bold text-solid-primary mr-3" @click.stop="$emit('closeDialog')">{{ $t("Actions.Cancel") }}</vs-button>
			<vs-button class="w-1/3 font-bold" @click.stop="confirmCancel">
				{{ $t("Actions.Confirm") }}
			</vs-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "TodoCancelConfirmDialog",
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		}
	},
	emits: {
		closeDialog: {},
		onClickAgree: {}
	},
	data() {
		return {
			cancelReason: ""
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		}
	},
	watch: {
		isDialogActiveLocal() {
			if (!this.isDialogActiveLocal) {
				this.cancelReason = "";
			}
		}
	},
	methods: {
		confirmCancel() {
			this.$validator.validateAll().then(validateionResult => {
				if (!validateionResult) return;
				this.$emit("onClickAgree", this.cancelReason);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
#cancel-todo-dialog {
	::v-deep .el-dialog {
		width: 510px;
		max-width: unset;
	}
}
</style>
